export default __webpack_public_path__ + "static/media/Pickpocket's Legguards of the Stolen Kingdom.8bdd6356.jpg";